<template>
  <div>
    message
  </div>
</template>

<script>
export default {
  name: 'Message'
}
</script>
